import gql from 'graphql-tag'

export const SC_DISPLAYS_PRESENTATIONS_FOR_POP_QUERY = gql`
  query($workspaceId: UUID!) {
    workspace(id: $workspaceId) {
      id
      displays {
        page
        count
        values {
          id
          name
          pixelsH
          pixelsW
          displayGroupId
          timezone {
            jodaId
          }
          schedulingType
          latitude
          longitude
          country {
            name
          }
          city
          street
        }
      }
      displayGroups{
        count
        values {
          id
          name
          pixelsH
          pixelsW
        }
      }
      presentations {
        page
        count
        values {
          id
          name
          type
          config
        }
      }
    }
  }
`

export const SC_GET_POP_RECORDS_WITH_SNAPSHOT_Q = gql`
  query ScGetPoPRecordsWithSnapshotQuery(
    $searchBy: SearchByEnum!
    $searchById: UUID!
    $workspaceId: UUID
    $startDate: String
    $endDate: String
  ) {
    getPoPRecordsWithSnapshot(
      getPoPRecordsWithSnapshotDTO: {
        searchBy: $searchBy
        searchById: $searchById
        workspaceId: $workspaceId
        startDate: $startDate
        endDate: $endDate
      }
    ) {
      popRecords {
        id
        accountId
        displayId
        playerId
        presentationId
        slideId
        startTime
        endTime
        playedCount
        duration
      }
    }
  }
`

// Reads the ClickHouse-native resolver. `pop_daily_rollup` already groups by
// the display-local day, so this one only groups by slideId and attaches
// snapshots, where the older `getMergedPoPRecordsWithSnapshot` re-derived the
// day from `startTime` (a UTC instant) and so collapsed two adjacent local
// days into one row for any display not on the API's timezone.
//
// Aliased back to the old field name so the response shape — and every
// consumer of it, including the generated types — is unchanged.
export const SC_GET_MERGED_POP_RECORDS_WITH_SNAPSHOT_Q = gql`
  query ScGetMergedPoPRecordsWithSnapshotQuery(
    $searchBy: SearchByEnum!
    $searchById: UUID!
    $workspaceId: UUID!
    $startDate: String
    $endDate: String
  ) {
    getMergedPoPRecordsWithSnapshot: getPoPRecordsBySlideIdAndStartDateAndPutSnapshots(
      getPoPRecordsWithSnapshotDTO: {
        searchBy: $searchBy
        searchById: $searchById
        workspaceId: $workspaceId
        startDate: $startDate
        endDate: $endDate
      }
    ) {
      mergedPoPRecords {
        slideId
        presentationId
        slideSnapshots
        mergedPoPRecordsWithSnapshotsAndTotalData {
          totalPlayedCount
          totalPlayedDurationInMillisecond
          popRecords {
            displayId
            startTime
            endTime
            lastStartTime
            playedCount
            playedDurationInMillisecond
          }
        }
      }
    }
  }
`
